import e from "@dialpad/dialtone-tokens/layered/themes/tokens-134-colors.css?inline";
//#region themes/134.js
var t = { brand: {
	css: e,
	name: "134"
} };
//#endregion
export { t as default };
